import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';

import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProductCapture from './pages/ProductCapture';
import ProductDashboard from './pages/ProductDashboard';
import Distribuidoras from './pages/Distribuidoras';
import Bots from './pages/Bots';
import Products from './pages/Operations/Products';
import Inventory from './pages/Operations/Inventory';
import Sales from './pages/Operations/Sales';
import HR from './pages/Operations/HR';
import Transport from './pages/Operations/Transport';
import Users from './pages/Settings/Users';
import useAuth from './hooks/useAuth';
import { setTokenProvider } from './config/api';

const theme = {
  token: {
    colorPrimary: '#E8192C',
    borderRadius: 8,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};

function AppContent() {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenProvider(getToken);
  }, [getToken]);

  return (
    <>
      <AuthenticatedTemplate>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/capture" element={<ProductCapture />} />
            <Route path="/dashboard/products" element={<ProductDashboard />} />
            <Route path="/distribuidoras" element={<Distribuidoras />} />
            <Route path="/bots" element={<Bots />} />
            <Route path="/operations/products" element={<Products />} />
            <Route path="/operations/inventory" element={<Inventory />} />
            <Route path="/operations/sales" element={<Sales />} />
            <Route path="/operations/hr" element={<HR />} />
            <Route path="/operations/transport" element={<Transport />} />
            <Route path="/settings/users" element={<Users />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </UnauthenticatedTemplate>
    </>
  );
}

function App() {
  return (
    <ConfigProvider theme={theme} locale={esES}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
